import { NgModule } from '@angular/core';
import { CanActivate, Routes, RouterModule } from '@angular/router';

// Import Containers
import { FullLayoutComponent, SimpleLayoutComponent } from './containers';

import { AuthGuard } from 'app/account/auth.guard';
import { NascarComponent } from 'app/nascar/nascar.component';
import { NascarResultsComponent }  from 'app/nascarresults/nascarresults.component';
import { NflComponent  } from 'app/nfl/nfl.component';
import { NflResultsComponent } from 'app/nflresults/nflresults.component';
import { SpreadManagerComponent } from 'app/nflmanager/spread-manager/spread-manager.component'
import { UserManagerComponent} from 'app/nflmanager/usermanager/usermanager.component'
import { ManageUserDriversComponent } from './admin/nascar/manageuserdrivers/manageuserdrivers.component';
//import { OrgsComponent } from './admin/orgs/orgs.component';
import { GamesComponent } from './admin/nfl/games/games.component';
import { ManageRacesComponent } from './admin/nascar/manageraces/manageraces.component';
import { SendComponent } from './admin/email/send/send.component';



export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    component: FullLayoutComponent,
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'dashboard',
        loadChildren: './views/dashboard/dashboard.module#DashboardModule'
      },
      // {
      //   path: 'admin',
      //   loadChildren: './admin/admin.module#AdminModule'
      // },
      {
        path: 'account',
        loadChildren: './account/account.module#AccountModule'
      },
      {
        path: 'nascar',
        component: NascarComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Nascar',
          roles: ['Administrators', 'Nascar User']
        }
      },
      {
        path: 'nascarresults',
        component: NascarResultsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Nascar Results',
          roles: ['Administrators', 'Nascar User']
        }
      },
      {
        path: 'nfl',
        component: NflComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'NFL',
          roles: ['Administrators', 'Football User']
        }
      },
      {
        path: 'nflresults',
        component: NflResultsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'NFL Results',
          roles: ['Administrators', 'Football User']
        }
      },
      {
        path: 'nflspreadmanager',
        component: SpreadManagerComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'NFL Spreads',
          roles: ['Administrators', 'Football Spread Manager']
        }
      },
      {
        path: 'nflusermanager',
        component: UserManagerComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'NFL Spreads',
          roles: ['Administrators', 'Football Manager']
        }
      },
      {
        path: 'admin/email/send',
        component: SendComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Send Emails',
          roles: ['Administrators']
        }
      },
      {
        path: 'admin/managenascarusers',
        component: ManageUserDriversComponent,
        data: {
          title: 'Manage Nascar Users'
        },
      },
      // {
      //   path: 'admin/orgs',
      //   component: OrgsComponent,
      //   data: {
      //     title: 'orgs'
      //   }
      // },
      {
        path: 'admin/games',
        component: GamesComponent,
        data: {
          title: 'games'
        }
      },
      {
        path: 'admin/manageraces',
        component: ManageRacesComponent,
        data: {
          title: 'manageraces'
        }
      }   
  
        
    ]
  
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/app.routing.ts